import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

  connect() {
    this.nextRow = this.element.nextElementSibling;
    this.nextRowContent = this.nextRow.querySelector(".row-content");

    var buttons = this.element.querySelectorAll("[data-toggle-button]");
    if (buttons.length > 0) {
      buttons.forEach((button) => {
        button.addEventListener("click", this.toggle.bind(this));
      });
    } else {
      this.element.addEventListener("click", this.toggle.bind(this));
    }
  }

  toggle(e) {
    // There's a limitation in height animations, which is nothing to do with Tailwind, just CSS.
    // If you want to animate, you have to have a specific start and end size.  To make this happen
    // We use an arbitrarily large max-height which should be big enough to accommodate the content.
    this.nextRowContent.classList.toggle("max-h-0");
    this.nextRowContent.classList.toggle("max-h-[1000px]");

    this.element.querySelectorAll("[data-toggle-button] [data-up], [data-toggle-button] [data-down]").forEach((el) => {
      el.classList.toggle("hidden");
    });
  }
}
